// This file is generated by next-core EcmascriptClientReferenceModule.
const { createClientModuleProxy } = require("react-server-dom-turbopack/server");

__turbopack_context__.n(createClientModuleProxy("[project]/Downloads/ui-main-fixed/ui-main/node_modules/next/dist/esm/client/components/render-from-template-context.js"));
